import { render } from "./Confirm.vue?vue&type=template&id=8121ee6a"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
script.render = render

export default script